import { useEffect } from "react";
import { useNavigate } from "react-router";
import { authClient } from "@/lib/auth-client";

export default function SignOut() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleSignOut = async () => {
      try {
        await authClient.signOut();
      } catch (error) {
        console.error("Sign out error:", error);
      }
      // Straight to the login screen: going through "/" let the home redirect
      // open a protected page with the session still cached for a moment, which
      // then sent the login screen a `redirect` to the previous account's home.
      navigate("/auth/login", { replace: true });
    };

    handleSignOut();
  }, [navigate]);

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      data-testid="sign-out-page"
    >
      <div className="text-center">
        <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-blue-600 border-b-2" />
        <p className="text-gray-600">Déconnexion…</p>
      </div>
    </div>
  );
}
